import { ActionTree, ActionContext } from 'vuex';
import { ReportApi } from '@/api/report-api';
import { ReportQueryFilters } from '@/models/reports/report-query-filters';
import { Mutations } from '@/stores/reports/mutation-constants';
import { State } from '@/stores/reports/state';
import { Operator } from '@/models/reports/report-operators';
import { SelectItem } from '@/models/reports/select-item';
import { LogicalOperator } from '@/models/reports/logical-operator';
import { ReportDetails } from '@/models/reports/report-details';

const api = new ReportApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchAsync = async (context: ActionContext<State, any>, filters: ReportQueryFilters) => {
        const result = await api.fetchAsync(filters);
        const reportArray = new Array<ReportDetails>();
        result.reports.forEach((report: any, index) => {
            reportArray.push(new ReportDetails(report));
        });
        context.commit(Mutations.SetAllReports, reportArray);
        context.commit(Mutations.SetAllReportsTotalPages, Math.ceil(result.total / ((result.pageSize < 1) ? 1 : result.pageSize)));
        context.commit(Mutations.SetAllReportsTotalReports, result.total);
    }
    public updateAllReportsPage = (context: ActionContext<State, any>, value: number) => {
        context.commit(Mutations.SetAllReportsPage, value);
    }

    public updateAllReportOperators = (context: ActionContext<State, any>, value: Array<SelectItem>) => {
        context.commit(Mutations.SetAllReportOperators, value);
    }

    public updateAllReportBooleanValues = (context: ActionContext<State, any>, value: Array<SelectItem>) => {
        context.commit(Mutations.SetAllReportBooleanValues, value);
    }

    public updateAllReportLogicalOperators = (context: ActionContext<State, any>, value: Array<Operator>) => {
        context.commit(Mutations.SetAllReportLogicalOperators, value);
    }
}
